/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dialog_Text_To_Audio_Listening_Time_MinutesInputs */

const en_dialog_text_to_audio_listening_time_minutes = /** @type {(inputs: Dialog_Text_To_Audio_Listening_Time_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.count} min`)
};

const es_dialog_text_to_audio_listening_time_minutes = /** @type {(inputs: Dialog_Text_To_Audio_Listening_Time_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.count} min`)
};

/**
* | output |
* | --- |
* | "~{count} min" |
*
* @param {Dialog_Text_To_Audio_Listening_Time_MinutesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_listening_time_minutes = /** @type {((inputs: Dialog_Text_To_Audio_Listening_Time_MinutesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Listening_Time_MinutesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_listening_time_minutes(inputs)
	return en_dialog_text_to_audio_listening_time_minutes(inputs)
});